import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getContractData, getContractTemplate, getTemplateContent, createContract, requestHigherDiscount, clientDetailsUpdateApi } from "../../../ReduxStore/Slice/Contract/contractSlice";
import { getEmailTemplate } from "../../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import Select from 'react-select';
import { useDispatch } from "react-redux";
import ReusableModal from "../../../ExtraComponents/ReusableModal";
import Loader from "../../../ExtraComponents/Loader";
import Swal from "sweetalert2";
import { agentList, agentDetails } from "../../../ReduxStore/Slice/Auth/AuthSlice";
import { getAllClient, getClientDetails } from "../../../Service/ThardPartyApi/ThardPartyAPI";

import {
  EMPTY_EMAIL_ERROR,
  EMPTY_SUBJECT_ERROR,
  EMPTY_SELECT_TEMPLET_ERROR,
  INVALID_EMAIL_ERROR,
  EMPTY_CC_EMAIL_ERROR,
  EMPTY_BCC_EMAIL_ERROR,
  INVALID_CC_EMAIL_ERROR,
  INVALID_BCC_EMAIL_ERROR,
  EMPTY_TEMPLET_BODY_ERROR
} from "../../../Utils/Common_Error";

import {
  ValidateEmail,
} from "../../../Utils/CommonFun";
import JoditEditor from 'jodit-react';
import * as Config from "../../../Utils/Config";
import axios from "axios";


const StepThree = ({ formData1, handleChange, nextStep, prevStep, currentStep }) => {

  // console.log("Stepfour rendered", formData1);

  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch();

  let ContractId = sessionStorage.getItem("contract_id");
  const editor = useRef(null);
  const userDetails = JSON.parse(localStorage.getItem("details"));
  if (location.state != undefined && location.state != null && location.state.record_id == undefined) {
    sessionStorage.setItem("contract_id", location.state.row.id);
    ContractId = location.state.row.id;
  }


  let backupQuoteId = ContractId;

  if (formData1 != undefined && formData1.contractid != undefined) {
    backupQuoteId = formData1.contractid;
  }

  if (location.state != null && location.state.row.id != undefined) {
    backupQuoteId = location.state.row.id;
  }

  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [quoteData, setQuoteData] = useState({});
  const [contractPackageServicesAll, setContractPackageServicesAll] = useState([]);
  const [allquotetemplate, setAllquotetemplate] = useState([]);
  const [agentListDataAuthorised, setAgentListDataAuthorised] = useState([]);
  const [complexityRiskPremium, setComplexityRiskPremium] = useState(0);

  const [existingChargeBasis, setExistingChargeBasis] = useState([]);

  const [allemailtemplate, setAllemailtemplate] = useState([]);
  const [content, setContent] = useState('');
  const [editorReady, setEditorReady] = useState(false);
  const [formData, setFormData] = useState({
    email_template_id: "",
    templateName: "",
    description: "",
    triggerEvent: "",
    subjectLine: "",
    bccEmail: "",
    replyTo: "",
    body: "",
    attachments: [],
  });

  const UpdateFormBody = useCallback((value) => {
    setFormData((prev) => {
      let updatedBody = prev.body.trim();

      const imgTag = `<img src="${value}" width="252" height="160" style="display: inline-block; margin-left: 5px; vertical-align: middle;"/>`;

      if (updatedBody.endsWith("<br>") || updatedBody.endsWith("</p>")) {
        updatedBody = updatedBody.replace(/(<br>|<\/p>)+$/, "");
      }

      updatedBody += ` ${imgTag}`;

      return { ...prev, body: updatedBody };
    });
  }, []);

  const config1 = useMemo(() => ({
    readonly: false,
    placeholder: "",
    buttons: "bold,italic,underline,strikethrough,ul,ol,paragraph,fontsize,font,brush,link,image,video,table,align,undo,redo,cut,copy,paste,selectall,source",
    removeButtons: ["speechRecognize"],
    toolbarSticky: false,
    uploader: {
      url: Config.base_url + "img/uploader",
      accept: "image/*,video/*",
      method: "POST",
      withCredentials: false,
      prepareData: async (formData1) => {
        const data = new FormData();
        formData1.forEach((file) => {
          data.append("files[0]", file);
        });

        try {
          const response = await axios.post(Config.base_url + "img/uploader", data, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.success && Array.isArray(response.data.files) && response.data.files.length > 0) {
            UpdateFormBody(response.data.files[0]);
            return {
              success: true,
              files: response.data.files,
              messages: response.data.messages || ["Image uploaded successfully"],
            };
          } else {
            return {
              success: false,
              files: [],
              messages: ["Image upload failed"],
            };
          }
        } catch (error) {
          console.error("Image upload error:", error);
          return {
            success: false,
            files: [],
            messages: ["Image upload failed"],
          };
        }
      },
      defaultHandlerSuccess: (response) => {
        if (response?.files?.length > 0) {
          return response.files;
        } else {
          console.error("No files in response:", response);
          return [];
        }
      },
      defaultHandlerError: (error) => {
        console.error("Image upload error:", error);
        return [];
      },
    },
    events: {
      afterInit: (editorInstance) => {
        setEditorReady(true);
        editor.current = editorInstance;
      },
    },
  }), [UpdateFormBody]);



  const [selectedTemplate, setSelectedTemplate] = useState({
    mail_to: '',
    cc_to: "",
    bcc_to: "",
    subject: '',
    template_id: '',
    template_body: ''
  });
  const [hasPackage, setHasPackage] = useState(false);
  const [clientid, setClientid] = useState("");
  const [error, setError] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templatePreviewContent, setTemplatePreviewContent] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [checkboxState, setCheckboxState] = useState({
    directorLetter: 0,
    selfAssessment: 0,
  });

  const [packageName, setPackageName] = useState("");
  const [package_id, setPackage_id] = useState("");
  const [emailAuthorised, setEmailAuthorised] = useState("");
  const [currentPackageDiscount, setCurrentPackageDiscount] = useState("");
  const [currentCost, setCurrentCost] = useState("");
  const [desiredHigherDiscount, setDesiredHigherDiscount] = useState(0);
  const [desiredPriceApproval, setDesiredPriceApproval] = useState(0);
  const [isCheckDirectorLetter, setIsCheckDirectorLetter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [errorDiscount, setErrorDiscount] = useState(false);
  const [errorDiscountValue, setErrorDiscountValue] = useState(false);
  const [showHigherDiscountButton, setShowHigherDiscountButton] = useState(false);
  const [isAgentListLoading, setIsAgentListLoading] = useState(false);
  const [reasonHigherDiscount, setReasonHigherDiscount] = useState("");

  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [clientDetails, setClientDetails] = useState({});
  const [loading, setLoading] = useState(false)

  const textareaRef = useRef(null);

  // console.log("errorDiscountValue", errorDiscountValue)


  const handleOpenModal = (templateId) => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    getAgentList();
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [textareaRef?.current?.scrollHeight, reasonHigherDiscount]);




  const getAgentList = async () => {
    if (agent_id === null) return
    const req = { agent_id: agent_id }
    await dispatch(agentDetails(req)).unwrap()
      .then(async (res) => {
        if (res.status) {

          let agent_authorised_users = res.data.agent_authorised_users
          if (agent_authorised_users !== null) {

            setAgentListDataAuthorised(JSON.parse(agent_authorised_users))
            setEmailAuthorised(JSON.parse(agent_authorised_users)[0].user_email)
          } else {
            setAgentListDataAuthorised([])
          }

        }
        else {
          setAgentListDataAuthorised([])
        }


      })
      .catch((err) => {
        console.log("Error", err)
      })
  }

  function cleanHtmlContent(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    const scripts = div.getElementsByTagName("script");
    const styles = div.getElementsByTagName("style");
    Array.from(scripts).forEach((script) => script.remove());
    Array.from(styles).forEach((style) => style.remove());
    const unorderedLists = div.querySelectorAll("ul");
    unorderedLists.forEach((list) => {
      list.style.listStyleType = "disc";
    });
    const orderedLists = div.querySelectorAll("ol");
    orderedLists.forEach((list) => {
      list.style.listStyleType = "decimal";
    });
    return div.innerHTML;

  }

  useEffect(() => {
    getQuote();
    getEmailTemplateFun();
  }, []);

  const getEmailTemplateFun = async () => {
    const req = { agent_id: agent_id, template_trriger_id: 2 };
    await dispatch(getEmailTemplate(req))
      .unwrap()
      .then(async (res) => {

        // console.log("res -- getEmailTemplate ", res);
        if (res.status) {
          if (res.data.length > 0) {
            setFormData({
              ...formData,
              email_template_id: res.data[0].id,
              body: res.data[0].body,
            });
          }
          setAllemailtemplate(res.data);
        } else {
          setAllemailtemplate([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // useEffect(() => {
  //   getQuoteTemplateFun();
  // }, [clientid]);

  const clientUpdateFunction = async () => {
    const req = { id: Number(ContractId), agent_id: agent_id, check: "getData" };
    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          // console.log("res.contract client ", res);
          const agent_db = localStorage.getItem('agent_db');
          const token_crm = localStorage.getItem('authClientToken');
          const agent_url = localStorage.getItem('agent_url');
          const company_id = JSON.parse(localStorage.getItem("company_id"));
          const req = {
            agent_db: agent_db,
            company_id: company_id,
            pricing_tool_pratice_id: agent_id,
            module: res.contract.Client.module_type,
            record_id: res.contract.Client.record_id || 0,
          };
          await getClientDetails(req, agent_url, token_crm).then(async (res) => {
            if (res.IsSuccess) {
              const req = {
                ClientDetails: res.result
              };

              await dispatch(clientDetailsUpdateApi(req)).unwrap()
                .then((res) => {
                  if (res.status) {
                  } else {

                  }
                })
                .catch((err) => {
                  console.log("err", err);
                });


            }

          }).catch((err) => {
            console.log("err", err);
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const getQuote = async () => {
    setIsLoading(true);
    await clientUpdateFunction();
    const req = { id: Number(ContractId), agent_id: agent_id };

    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {

        if (res.status) {

          // console.log("Final quoteData", res?.contract?.ContractEnterDefaultValues)
          const chargeBasisIds = res?.contract?.ContractPackageServices?.flatMap(item =>
            item.Service?.ServiceChargeBases?.map(cb => cb.chargebasis_id) || []
          );

          //  console.log("chargeBasisIds", chargeBasisIds);
          const matchingItems = res?.contract?.ContractEnterDefaultValues?.filter(item => chargeBasisIds.includes(item.chargebasis_id));
          // console.log("matchingItems", matchingItems);
          setExistingChargeBasis(matchingItems);

          const missingChageBasisChargeType = matchingItems?.filter(
            item =>
              item.chargetype_rule_id === null &&
              item.inputValue === null &&
              item.individual_id === null
          );
          if (missingChageBasisChargeType.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Warning",
              text: "The default charge basis used in this contract has been removed. Please create a new one or go back and change the value.",
              timer: 20000,
              timerProgressBar: true,
            });
            return;
          }



          setReasonHigherDiscount(res?.contract?.reason_higher_discount || "");
          if (Number(res?.contract?.higher_discount_status) == 0) {
            setShowHigherDiscountButton(true)
          }

          setClientid(res.contract.client_id)
          if (["COMPANY", "LLP"].includes((res.contract.EnquiryType.name).toUpperCase())) {
            setIsCheckDirectorLetter(true)
          }
          // setSelectedTemplate({
          //   ...selectedTemplate,
          //   mail_to: res.contract.Client.email,
          // })

          if (res.contract.ContractPackageServices != undefined && res.contract.ContractPackageServices != null && res.contract.ContractPackageServices.length > 0) {
            setContractPackageServicesAll(res.contract.ContractPackageServices)
          }
          setQuoteData(res.contract)
          setHasPackage(res.hasPackage)
          getQuoteTemplateFun(res.contract.Client.email, res.contract.client_id, res.contract.contact_owner);

          //console.log("res.contract", res.PackageDetails)

          let existpackageDetals = res.PackageDetails.ContractPackageServices.find((val) => val.Package != null)
          if (existpackageDetals != undefined && existpackageDetals != null) {
            setPackageName(existpackageDetals.Package.name)
            setPackage_id(existpackageDetals.Package.id)

            //  console.log("existpackageDetals", existpackageDetals)
            //  console.log("res.contract.discount_ongoing", res.contract)

            let complexity_risk_premium = parseFloat(res.contract.complexity_premium) + parseFloat(res.contract.risk_premium)



            if (Number(res.contract.status_discount_ongoing) == 1) {
              setCurrentPackageDiscount(res.contract.discount_ongoing)
              let currentCost = await currentCostFun(res.contract.discount_ongoing, res.contract.ContractPackageServices)
              setCurrentCost(currentCost)
            }


            if ((parseFloat(existpackageDetals.Package.default_discount) === parseFloat(res.contract.discount_ongoing)) && parseFloat(complexity_risk_premium) == 0 && parseFloat(res.contract.premium_ongoing) == 0) {
              setCurrentCost(existpackageDetals.Package.default_price)
            }

          } else {
            setPackageName("")
          }
        } else {
          setClientid('')
          setQuoteData({})
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    // setIsLoading(false);
  };

  const getQuoteTemplateFun = async (email, client_id, contact_owner) => {
    const req = { id: Number(ContractId), agent_id: agent_id };
    await dispatch(getContractTemplate(req)).unwrap()
      .then(async (res) => {

        //console.log("res --- getQuoteTemplateFun ", res)
        if (res.status) {
          setAllquotetemplate(res.data)
          if (res.data.length > 0) {
            setSelectedTemplate({
              ...selectedTemplate,
              mail_to: email,
              template_id: res.data[0].id,
              subject: res.data[0].subject
            })
            await getTemplateContentFun(res.data[0].id, client_id, contact_owner);
          } else {
            setSelectedTemplate({
              ...selectedTemplate,
              mail_to: email,
              template_id: '',
              subject: ''
            })
          }

        } else {
          setAllquotetemplate([])
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const selectValueOnChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "email_template_id") {
      const selectedTemplate = allemailtemplate.find(
        (template) => Number(template.id) === Number(value)
      );
      setFormData({
        ...formData,
        email_template_id: value,
        body: selectedTemplate ? selectedTemplate.body : "",
      });
      validate(name, value);
      return;
    }

    validate(name, value);
    setSelectedTemplate({
      ...selectedTemplate,
      [name]: value
    })
    if (name === 'template_id') {
      await getTemplateContentFun(value, quoteData?.client_id, quoteData?.contact_owner)
    }

  }


  const getTemplateContentFun = async (id, client_id, contact_owner) => {
    const req = { id: id, clientid: client_id, agent_id: agent_id, ContractOwner: contact_owner, quote_id: ContractId };
    setIsLoading(true);
    await dispatch(getTemplateContent(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          setTemplatePreviewContent(res.content)
          allquotetemplate && allquotetemplate?.find((val) => {
            if (Number(val.id) === Number(id)) {
              setSelectedTemplate({
                ...selectedTemplate,
                template_id: id,
                subject: val.subject
              })
            }
          })
          setIsLoading(false);
        } else {
          setTemplatePreviewContent('')
          setIsLoading(false);

        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
    setIsLoading(false);
  }

  const validate = async (name, value) => {
    const newErrors = { ...error };
    if (!value?.trim()) {
      if (name === "mail_to") newErrors[name] = EMPTY_EMAIL_ERROR;
      else if (name === "subject") newErrors[name] = EMPTY_SUBJECT_ERROR;
      else if (name === "template_id") newErrors[name] = EMPTY_SELECT_TEMPLET_ERROR;
      else if (name === "cc_to" || name === "bcc_to") {
        delete newErrors[name]; // clear any previous error
      }
      else if (name === "body") {
        newErrors[name] = EMPTY_TEMPLET_BODY_ERROR;
      }
    }
    // else if (name === "mail_to" && !/^[a-zA-Z0-9._%+-]+@(gmail|yahoo|outbooks|outbook|nomi|rediffmail|hotmail|outlook|aol|icloud|protonmail|example)\.(com|co\.in|in|net|org|edu|gov|uk|us|info|biz|io|...)[a-zA-Z]{0,}$/.test(value)) {
    //   newErrors[name] = INVALID_EMAIL_ERROR;
    // }
    else if (name === "mail_to") {
      let valid = await ValidateEmail(value)
      if (!valid) {
        newErrors[name] = INVALID_EMAIL_ERROR;
      } else {
        delete newErrors[name];
      }
    }

    // else if (name === "cc_to" && !/^[a-zA-Z0-9._%+-]+@(gmail|yahoo|outbooks|outbook|nomi|rediffmail|hotmail|outlook|aol|icloud|protonmail|example)\.(com|co\.in|in|net|org|edu|gov|uk|us|info|biz|io|...)[a-zA-Z]{0,}$/.test(value)) {
    //   newErrors[name] = INVALID_CC_EMAIL_ERROR;
    // } 

    else if (name === "cc_to") {
      let valid = await ValidateEmail(value)
      if (!valid) {
        newErrors[name] = INVALID_CC_EMAIL_ERROR;
      } else {
        delete newErrors[name];
      }
    }

    // else if (name === "bcc_to" && !/^[a-zA-Z0-9._%+-]+@(gmail|yahoo|outbooks|outbook|nomi|rediffmail|hotmail|outlook|aol|icloud|protonmail|example)\.(com|co\.in|in|net|org|edu|gov|uk|us|info|biz|io|...)[a-zA-Z]{0,}$/.test(value)) {
    //   newErrors[name] = INVALID_BCC_EMAIL_ERROR;
    // }
    else if (name === "bcc_to") {
      let valid = await ValidateEmail(value)
      if (!valid) {
        newErrors[name] = INVALID_BCC_EMAIL_ERROR;
      } else {
        delete newErrors[name];
      }
    }


    else {
      delete newErrors[name];
    }
    setError(newErrors);
    return Object.keys(newErrors).length === 0 ? true : false;
  };

  const handleSubmit = async () => {

    const missingChageBasisChargeType = existingChargeBasis?.filter(
      item =>
        item.chargetype_rule_id === null &&
        item.inputValue === null &&
        item.individual_id === null
    );
    if (missingChageBasisChargeType.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "The default charge basis used in this contract has been removed. Please create a new one or go back and change the value.",
        timer: 20000,
        timerProgressBar: true,
      });
      return;
    }


    let payment_type = 0
    if (quoteData.payment_term_oneoff != null && quoteData.payment_term_oneoff != "" && quoteData.payment_term_oneoff != undefined && (quoteData.payment_term_oneoff == "monthly_dd" || quoteData.payment_term_oneoff == "quarterly_dd")) {
      payment_type = 1
    }

    if (quoteData.payment_term_ongoing != null && quoteData.payment_term_ongoing != "" && quoteData.payment_term_ongoing != undefined && (quoteData.payment_term_ongoing == "monthly_dd" || quoteData.payment_term_ongoing == "quarterly_dd")) {
      payment_type = 1
    }



    let valid = true;
    if (!selectedTemplate.mail_to) {
      error.mail_to = EMPTY_EMAIL_ERROR;
      valid = false;
    }
    if (!selectedTemplate.subject) {
      error.subject = EMPTY_SUBJECT_ERROR;
      valid = false;
    }
    if (!selectedTemplate.template_id) {
      error.template_id = EMPTY_SELECT_TEMPLET_ERROR;
      valid = false;
    }


    setError({ ...error });
    if (valid) {
      setDisableSubmit(true);
      setIsLoading(true);
      const req = {
        id: Number(ContractId),
        step: 4,
        mail_to: selectedTemplate.mail_to,
        subject: selectedTemplate.subject,
        template_id: selectedTemplate.template_id,
        clientid: clientid,
        ContractOwner: userDetails.id,
        agent_id: agent_id,
        director_letter: checkboxState.directorLetter,
        self_assessment: checkboxState.selfAssessment,
        payment_type: payment_type,
        cc_to: selectedTemplate.cc_to || "",
        bcc_to: selectedTemplate.bcc_to || "",
        email_template_details: formData,
        backupQuoteId: backupQuoteId

      }
      // setLoading(true);
      await dispatch(createContract(req)).unwrap()
        .then((res) => {
          // console.log("res createContract", res);
          if (res.status == true) {
            setIsLoading(false);
            sessionStorage.clear();
            navigate("/admin/contracts/contracts-dashboard");
            // setIsLoading(false);
            // Swal.fire({
            //   icon: "success",
            //   title: "Success",
            //   text: res.message,
            //   timer: 3000,
            //   timerProgressBar: true,
            // }).then(() => {
            //   sessionStorage.clear();
            //   navigate("/admin/contracts/contracts-dashboard");
            // });


          }
          else {

            setDisableSubmit(false);

            if (res.message.includes("_____________")) {

              Swal.fire({
                icon: "warning",
                title: "Warning..",
                text: "Signature Tag Is Missing In The Document.",
                timer: 3000,
                timerProgressBar: true,
              });
              return;
            } else {

              Swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                timer: 3000,
                timerProgressBar: true,
              })
              return;
            }

          }
        }).catch((err) => {
          setIsLoading(false);
          setDisableSubmit(false);
          console.log("err", err);
        })
    }
  }

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked ? 1 : 0,
    }));
  };

  const currentCostFun = async (discount, ContractPackageServices) => {
    let total_price = 0;
    if (discount == "") {
      return total_price
    }
    await ContractPackageServices.forEach(async (service) => {
      if (Number(service.service_type) == 1) {

        let price_afterdiscount = service.price - (service.price * discount) / 100;
        total_price += price_afterdiscount;
      }
    });
    return total_price;
  }

  const setDesiredHigherDiscountFun = async (e) => {
    let value = e.target.value;
    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      value = ""
      setDesiredHigherDiscount(value);
      let currentCost = await currentCostFun(value, quoteData && quoteData?.ContractPackageServices)
      setDesiredPriceApproval(currentCost)
      return
    }

    else if (value > 100) {
      value = 100;
    }

    if (parseFloat(value) <= parseFloat(currentPackageDiscount)) {
      setErrorDiscount(true)
    } else {
      setErrorDiscount(false)
    }

    setDesiredHigherDiscount(value);
    let currentCost = await currentCostFun(value, quoteData && quoteData?.ContractPackageServices)
    setDesiredPriceApproval(currentCost)
  }

  const desiredPriceApprovalFun = async (e) => {
    let value = e.target.value;

    if (value === '.') {
      value = "0.";
    }

    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      return
    }



    if (parseFloat(value) > parseFloat(currentCost)) {
      setDesiredHigherDiscount(0);
      setErrorDiscountValue(true);
    } else if (value === "") {
      setErrorDiscountValue(true);
    }
    else {

      let total_price = 0;
      await quoteData?.ContractPackageServices?.forEach(async (service) => {
        if (Number(service.service_type) == 1) {
          let price_afterdiscount = service.price;
          total_price += price_afterdiscount;
        }
      });
      const discountPercent = ((total_price - value) / total_price) * 100;
      setDesiredHigherDiscount(discountPercent.toFixed(2));
      setErrorDiscountValue(false);
    }
    setDesiredPriceApproval(value);

  }

  const [approvalErrors, setApprovalErrors] = useState({});


  const submitReqHigherDiscount = async (e) => {
    // if (parseFloat(desiredHigherDiscount || 0) <= parseFloat(currentPackageDiscount)) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Warning..",
    //     text: "Please Enter Higher Discount Than Current Discount",
    //     timer: 2000,
    //     timerProgressBar: true,
    //   });
    //   return;
    // }

    // if (errorDiscount == true) {
    //   return;
    // }

    if (errorDiscountValue == true) {
      return;
    }


    if (!['', null, undefined].includes(package_id)) {
      if (errorDiscountValue == true) {
        return;
      }
      if (parseFloat(desiredPriceApproval) === 0) {
        Swal.fire({
          icon: "warning",
          title: "Warning..",
          text: "Please Enter Desired Price Approval",
          timer: 5000,
          timerProgressBar: true,
        });
        return;
      }
    }

    let errorShow = Object.values(approvalErrors).every(value => value === '');

    if (!errorShow) {
      return
    }


    let req = {
      type: 1,
      contract_id: Number(ContractId),
      agent_id: agent_id,
      user_id: userDetails.id,
      client_id: clientid,
      email: emailAuthorised,
      package_id: package_id,
      current_discount: currentPackageDiscount,
      current_cost: currentCost,
      discount: desiredHigherDiscount || 0,
      cost: parseFloat(desiredPriceApproval),
      reason_higher_discount: reasonHigherDiscount,
    }

    if (currentCost == "" && package_id == "") {

      // let current_cost = contractPackageServicesAll && contractPackageServicesAll.length > 0 ? contractPackageServicesAll.reduce((sum, item) => sum + item.price, 0).toFixed(2) : 0


      // let cost = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll
      //     .reduce((sum, item) => {
      //       const price =
      //         item.approval_price !== undefined
      //           ? parseFloat(item.approval_price || 0)
      //           : item.price_afterdiscount;
      //       return sum + price;
      //     }, 0).toFixed(2) : 0


      // let current_discount = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll.find((item) => item.discount_rate)?.discount_rate : 0

      // let discount = (((current_cost || 0) - (cost || 0)) / (current_cost || 0)) * 100;


      // console.log("current_cost", current_cost)
      // console.log("cost", cost)
      // console.log("current_discount", current_discount)
      // console.log("discount", discount)






      // Calculate current_cost excluding BasisType.id === 2
      // let current_cost = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll.reduce((sum, item) => {
      //     const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;
      //     const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
      //       cb.ChargeBasis?.id === chargeBasisId &&
      //       cb.ChargeBasis?.BasisType?.id === 2
      //     );
      //     if (exclude) return sum;
      //     return sum + (item.price || 0);
      //   }, 0).toFixed(2)
      //   : 0;

      // // Calculate cost (approval_price or price_afterdiscount) excluding BasisType.id === 2
      // let cost = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll.reduce((sum, item) => {
      //     const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;
      //     const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
      //       cb.ChargeBasis?.id === chargeBasisId &&
      //       cb.ChargeBasis?.BasisType?.id === 2
      //     );
      //     if (exclude) return sum;
      //     const price = item.approval_price !== undefined
      //       ? parseFloat(item.approval_price || 0)
      //       : item.price_afterdiscount || 0;
      //     return sum + price;
      //   }, 0).toFixed(2)
      //   : 0;

      // // Get current_discount from first non-excluded item
      // let current_discount = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? (contractPackageServicesAll.find(item => {
      //     const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;
      //     const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
      //       cb.ChargeBasis?.id === chargeBasisId &&
      //       cb.ChargeBasis?.BasisType?.id === 2
      //     );
      //     return !exclude && item.discount_rate !== undefined;
      //   })?.discount_rate || 0)
      //   : 0;

      // // Calculate discount percentage
      // let discount = current_cost && cost
      //   ? (((parseFloat(current_cost) - parseFloat(cost)) / parseFloat(current_cost)) * 100).toFixed(2)
      //   : 0;


      const services = contractPackageServicesAll || [];

      const getChargeBasisId = (item) =>
        item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

      const isExcluded = (item) => {
        const chargeBasisId = getChargeBasisId(item);
        return chargeBasisId && item.Service?.ServiceChargeBases?.some(
          (cb) =>
            cb.ChargeBasis?.id === chargeBasisId &&
            cb.ChargeBasis?.BasisType?.id === 2
        );
      };

      // 👉 1. Calculate current_cost (based on item.price)
      const current_cost = services.reduce((sum, item) => {
        if (isExcluded(item)) return sum;
        return sum + (parseFloat(item.price) || 0);
      }, 0).toFixed(2);

      // 👉 2. Calculate cost (based on approval_price or price_afterdiscount)
      const cost = services.reduce((sum, item) => {
        if (isExcluded(item)) return sum;
        const price =
          item.approval_price !== undefined && item.approval_price !== null
            ? parseFloat(item.approval_price || 0)
            : parseFloat(item.price_afterdiscount || 0);
        return sum + price;
      }, 0).toFixed(2);

      // 👉 3. Get current_discount from first non-excluded item
      const current_discount = services.find((item) => {
        return !isExcluded(item) && item.discount_rate !== undefined;
      })?.discount_rate || 0;

      // 👉 4. Calculate discount percentage
      const discount =
        parseFloat(current_cost) && parseFloat(cost)
          ? (((parseFloat(current_cost) - parseFloat(cost)) / parseFloat(current_cost)) * 100).toFixed(2)
          : "0.00";


      // console.log("current_cost", current_cost)
      // console.log("cost", cost)
      // console.log("current_discount", current_discount)

      // console.log("discount", discount)



      req = {
        type: 2,
        contract_id: Number(ContractId),
        agent_id: agent_id,
        user_id: userDetails.id,
        client_id: clientid,
        email: emailAuthorised,
        current_discount: current_discount,
        current_cost: current_cost,
        discount: discount || 0,
        cost: cost,
        contractPackageServicesAll: contractPackageServicesAll,
        reason_higher_discount: reasonHigherDiscount,
      }

    }


    setLoading(true)
    await dispatch(requestHigherDiscount(req)).unwrap()
      .then(async (res) => {

        if (res.status) {
          setDesiredHigherDiscount(0);
          setDesiredPriceApproval(0);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Higher Discount Request Sent Successfully",
            timer: 4000,
            timerProgressBar: true,
          }).then(() => {
            setShowModal(false);
            //getQuote();
            sessionStorage.clear();
            navigate("/admin/contracts/contracts-dashboard");
          });

          // setDesiredHigherDiscount(0);
          // setDesiredPriceApproval(0);
          // setShowModal(false);
          // sessionStorage.clear();
          // navigate("/admin/contracts/contracts-dashboard");



        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            timer: 3000,
            timerProgressBar: true,
          });
        }

      })
      .catch((err) => {
        console.log("Error", err)
      }).finally(() => {
        setLoading(false);
      });
  }

  const applyApprovalPrice = async (e, item, index) => {
    let value = e.target.value;

    const isValid = /^\d*\.?\d*$/.test(value);
    if (!isValid) return;

    if (parseFloat(value) > item.price) {
      setApprovalErrors(prevErrors => ({
        ...prevErrors,
        [index]: 'Approval price cannot be greater than original price.'
      }));
      return;
    }

    if (item.price_afterdiscount < parseFloat(value)) {
      setApprovalErrors(prevErrors => ({
        ...prevErrors,
        [index]: 'Approval price cannot be greater than discounted price.'
      }));
      return;
    }

    setApprovalErrors(prevErrors => ({
      ...prevErrors,
      [index]: ''
    }));



    const originalPrice = item.price;
    const approvalPrice = parseFloat(value || 0);
    const discount = ((originalPrice - approvalPrice) / originalPrice) * 100;

    const updatedServices = [...contractPackageServicesAll];
    updatedServices[index] = {
      ...updatedServices[index],
      approval_price: value,
      approval_discount: discount,
    };

    setContractPackageServicesAll(updatedServices);
  }

  const viewPdfFunction = async (template) => {

    const missingChageBasisChargeType = existingChargeBasis?.filter(
      item =>
        item.chargetype_rule_id === null &&
        item.inputValue === null &&
        item.individual_id === null
    );
    if (missingChageBasisChargeType.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "The default charge basis used in this contract has been removed. Please create a new one or go back and change the value.",
        timer: 20000,
        timerProgressBar: true,
      });
      return;
    }



    const TemaplateName =
      allquotetemplate?.find(
        (val) => Number(val.id) === Number(template.template_id)
      )?.name || "Contract Template";

    setIsLoading(true);
    let payment_type = 0;

    if (
      quoteData.payment_term_oneoff &&
      (quoteData.payment_term_oneoff === "monthly_dd" ||
        quoteData.payment_term_oneoff === "quarterly_dd")
    ) {
      payment_type = 1;
    }

    if (
      quoteData.payment_term_ongoing &&
      (quoteData.payment_term_ongoing === "monthly_dd" ||
        quoteData.payment_term_ongoing === "quarterly_dd")
    ) {
      payment_type = 1;
    }

    const req = {
      id: Number(ContractId),
      step: 4,
      mail_to: selectedTemplate.mail_to,
      subject: selectedTemplate.subject,
      template_id: selectedTemplate.template_id,
      clientid: clientid,
      ContractOwner: userDetails.id,
      agent_id: agent_id,
      director_letter: checkboxState.directorLetter,
      self_assessment: checkboxState.selfAssessment,
      payment_type: payment_type,
      cc_to: selectedTemplate.cc_to || "",
      bcc_to: selectedTemplate.bcc_to || "",
      email_template_details: formData,
      view_pdf: true,
      backupQuoteId: backupQuoteId
    };

    try {
      const res = await dispatch(createContract(req)).unwrap();
      if (res.status) {
        const base64String = res.data;
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);

        setPdfUrl(blobUrl);
        setShowPdfModal(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.msg,
          timer: 9000,
          timerProgressBar: true,
        });
      }

    } catch (err) {
      console.log("Error", err);
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to generate PDF. Please try again.",
        timer: 5000,
        timerProgressBar: true,
      });
    }

  };


  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: '',
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'transparent',
        backdrop: 'rgba(229, 233, 236, 0.2)',
       // timer: 8000,
        customClass: {
          popup: 'no-shadow',
        }
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (

    <div>
      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title" >
            <i className='bx bx-arrow-back text-pink pe-1' onClick={() => prevStep(false)}></i>

            New Contract{" "}
            <span>
              {" "}

            </span>
          </h4>
        </div>
      </div>




      <div className="card pt-4">

        <div className="card-body">
          <div className="row">
            <div className="col-lg-3">
              <h4 className="card-title mb-4">Send Contract</h4>
            </div>
            <div className="col-lg-5 row">
              {
                isCheckDirectorLetter ? (
                  <div className="col-lg-6">
                    <input
                      type="checkbox"
                      name="directorLetter"
                      className="form-check-input mx-2"
                      checked={checkboxState.directorLetter === 1}
                      onChange={handleCheckboxChange}
                    />
                    <label className="form-label">Director Letter</label>
                  </div>
                ) : ""
              }

              <div className="col-lg-6">
                <input
                  type="checkbox"
                  name="selfAssessment"
                  className="form-check-input mx-2"

                  checked={checkboxState.selfAssessment === 1}
                  onChange={handleCheckboxChange}
                />
                <label className="form-label">Self Assessment</label>
              </div>
            </div>

            {/* {packageName !== "" ?
              <div className="col-lg-4">
                <div className="offset-lg-5">
                  <button className="btn btn-pink" onClick={() => setShowModal(true)}>Request Higher Discount</button>
                </div>
              </div>
              : ""} */}
            {
              showHigherDiscountButton ?
                <div className="col-lg-4">
                  <div className="offset-lg-4">
                    <button className="btn btn-pink" onClick={() => setShowModal(true)}>Request Higher Discount</button>
                  </div>
                </div>
                : ""
            }




          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Mail To
                </label>
                <input
                  type="text"
                  name="mail_to"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => selectValueOnChange(e)} value={selectedTemplate.mail_to}
                />
                {error.mail_to && (
                  <p className="text-danger">{error.mail_to}</p>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  CC
                </label>
                <input
                  type="text"
                  name="cc_to"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => selectValueOnChange(e)}
                  value={selectedTemplate.cc_to}
                />
                {error.cc_to && (
                  <p className="text-danger">{error.cc_to}</p>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  BCC
                </label>
                <input
                  type="text"
                  name="bcc_to"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => selectValueOnChange(e)}
                  value={selectedTemplate.bcc_to}
                />
                {error.bcc_to && (
                  <p className="text-danger">{error.bcc_to}</p>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Select Email Template
                </label>
                <select
                  className="form-select"
                  name="email_template_id"
                  onChange={(e) => selectValueOnChange(e)}
                >
                  {allemailtemplate && allemailtemplate?.map((val, index) => (
                    <option
                      key={index}
                      value={val.id}
                      selected={val.id === formData.email_template_id}
                    >
                      {val.name}
                    </option>
                  ))}
                </select>
                {/* {error.template_id && (
                                  <p className="text-danger">{error.template_id}</p>
                                )} */}
              </div>
            </div>

            <div className="col-md-12">
              <div className="row">

                <label for="exampleInputEmail1" className="form-label">
                  Body
                </label>
                <div className="col-sm-12">
                  <JoditEditor
                    ref={editor}
                    config={config1}
                    tabIndex={1}
                    onBlur={(newContent) => setContent(newContent)}
                    name="body"
                    onChange={(value) => {
                      setFormData({ ...formData, body: value });
                      validate("body", value);
                    }}
                    value={formData.body || ""}
                  />
                  {error.body && <div className="error-text">{error.body}</div>}

                </div>
              </div>
            </div>


            <div className="col-md-12 mt-3">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => selectValueOnChange(e)} value={selectedTemplate.subject} />
              </div>
              {error.subject && (
                <p className="text-danger">{error.subject}</p>
              )}
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Select PDF Template
                </label>
                <select className="form-select"
                  name="template_id"
                  onChange={(e) => selectValueOnChange(e)}
                  value={selectedTemplate.template_id}
                >
                  {
                    allquotetemplate?.map((val, index) => (
                      <option key={index}
                        value={val.id}
                        selected={val.id === selectedTemplate.template_id}
                      >
                        {val.name}
                      </option>
                    ))

                  }
                </select>
                {error.template_id && (
                  <p className="text-danger">{error.template_id}</p>
                )}

                {/* <a
                  href="#"
                  className="mt-2 d-block text-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenModal(selectedTemplate.template_id);
                  }}
                >
                  Preview Template
                </a> */}

                <a
                  href="#"
                  className="mt-2 d-block text-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    viewPdfFunction(selectedTemplate);
                  }}
                >
                  Preview PDF
                </a>

                {showPdfModal && (
                  <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">PDF Preview</h5>

                          {/* Open in New Tab Button */}
                          <a
                            href={pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-pink ms-2 btn-sm"
                            style={{ fontSize: '10px' }}
                          >
                            Open in New Tab
                          </a>

                          {/* Close Button */}
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowPdfModal(false)}
                          ></button>
                        </div>

                        <div className="modal-body">
                          <iframe
                            src={pdfUrl}
                            title="PDF Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                )}

              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between mt-3">
            {currentStep > 1 && (
              <button className="btn btn-secondary" onClick={() => prevStep(false)}>
                Previous
              </button>
            )}
            <button
              disabled={disableSubmit}
              className="btn btn-pink"
              onClick={handleSubmit}
            >
              {currentStep < 4 ? "Next" : "Send"}
            </button>
          </div>
        </div>
      </div>


      {isModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Template Preview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>

              <div
                className="modal-body preview-body"
                dangerouslySetInnerHTML={{ __html: templatePreviewContent || "" }}
                readOnly
              />
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {
        packageName !== "" ?
          <>
            {/* package request higher discount modal  */}
            <ReusableModal
              show={showModal}
              onClose={() => setShowModal(false)}
              modalsize="lg"
              title={
                <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>Request Higher Discount</span>
              }
              body={
                <>
                  <div className="p-3 rounded">
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Approved By:</label>
                      </div>

                      <div className="col-md-8">
                        <select
                          className="form-select"
                          onChange={(e) => { setEmailAuthorised(e.target.value) }}
                        >
                          {agentListDataAuthorised && agentListDataAuthorised?.map((val, index) => (
                            <option
                              key={index}
                              value={val?.user_email}
                              selected={val?.user_email === emailAuthorised}
                            >

                              {val?.user_fname + ' ' + val?.user_lname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Package:</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          value={packageName && packageName}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Current Package Discount (%):</label>

                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          value={currentPackageDiscount && currentPackageDiscount + '%'}
                        />

                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Current Cost:</label>

                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          value={currentCost && '£' + currentCost.toFixed(2)}
                        />

                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Desired Higher Discount (%):</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          type="text"
                          max={100}
                          value={desiredHigherDiscount && desiredHigherDiscount + '%'}
                          onChange={(e) => {
                            setDesiredHigherDiscountFun(e);
                          }}
                        />
                        {/* {
                          desiredHigherDiscount === "" ?
                            <span className="text-danger">Please enter desired higher discount</span> :
                            errorDiscount ? <span className="text-danger">Discount can not be less than {currentPackageDiscount}</span> : ""
                        } */}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Desired Price for Approval:</label>

                      </div>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          type="text"
                          value={desiredPriceApproval}
                          onChange={(e) => desiredPriceApprovalFun(e)}
                        />
                        {
                          desiredPriceApproval === "" ?
                            <span className="text-danger">Please enter desired price for approval</span> :
                            errorDiscountValue ? <span className="text-danger">Desired Price can not be greater than current cost {currentCost.toFixed(2)}</span> : ""
                        }
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-sm-4 col-md-2 col-form-label">
                        <strong>Reason:</strong>
                      </label>
                      <div className="col-sm-8 col-md-10 ">
                        <textarea
                          ref={textareaRef}
                          value={reasonHigherDiscount}
                          name="reason_higher_discount"
                          onChange={(e) => setReasonHigherDiscount(e.target.value)}
                          placeholder="Please Enter Reason For Higher Discount"
                          style={{
                            width: "100%",
                            minHeight: "40px",
                            maxHeight: "300px",
                            overflowY: "hidden",
                            padding: "8px",
                            fontSize: "16px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              }
              footer={
                <>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-pink" onClick={(e) => submitReqHigherDiscount(e)}
                    disabled={loading}
                  >{loading ? "Submitting..." : "Submit"}</button>
                </>
              }
            />
          </>

          :

          <>
            {/* Only Service request higher discount modal  */}
            <ReusableModal
              show={showModal}
              onClose={() => setShowModal(false)}
              modalsize="xl"
              title={
                <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>Request Higher Discount Services</span>
              }
              body={
                <>
                  <div className="p-3 rounded">
                    <div className="row mb-3">
                      <div className="col-md-4"> <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Approved By:</label>
                        </div>
                        <div className="col-md-6">
                          <select className="form-select" onChange={(e) => { setEmailAuthorised(e.target.value) }}>
                            {agentListDataAuthorised && agentListDataAuthorised?.map((val, index) => (
                              <option
                                key={index}
                                value={val?.user_email}
                                selected={val?.user_email === emailAuthorised}
                              >

                                {val?.user_fname + ' ' + val?.user_lname}</option>
                            ))}
                          </select>
                        </div>
                      </div></div>

                      <div className="col-md-4"> <div className="row mb-3">
                        <div className="col-md-10">

                          {/* <p className="form-label">Total Current Price : &pound;{contractPackageServicesAll && contractPackageServicesAll.length > 0 ? contractPackageServicesAll.reduce((sum, item) => sum + item.price_afterdiscount, 0).toFixed(2) : 0}
                          </p> */}
                          <p className="form-label">
                            Total Current Price : &pound;
                            {
                              contractPackageServicesAll && contractPackageServicesAll.length > 0
                                ? contractPackageServicesAll.reduce((sum, item) => {
                                  const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                  const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                    cb.ChargeBasis?.id === chargeBasisId &&
                                    cb.ChargeBasis?.BasisType?.id === 2
                                  );

                                  return exclude ? sum : sum + (item.price_afterdiscount || 0);
                                }, 0).toFixed(2)
                                : 0
                            }
                          </p>
                        </div>
                      </div></div>
                      <div className="col-md-4">  <div className="row mb-3">
                        <div className="col-md-12">
                          {/* <label className="form-label">
                            Total Price For Approval: &pound;
                            {contractPackageServicesAll && contractPackageServicesAll.length > 0
                              ? contractPackageServicesAll
                                .reduce((sum, item) => {
                                  const price =
                                    item.approval_price !== undefined
                                      ? parseFloat(item.approval_price || 0)
                                      : item.price_afterdiscount;
                                  return sum + price;
                                }, 0).toFixed(2)
                              : 0}
                          </label> */}
                          <label className="form-label">
                            Total Price For Approval: &pound;
                            {/* {console.log("contractPackageServicesAll", contractPackageServicesAll)} */}
                            {
                              contractPackageServicesAll && contractPackageServicesAll.length > 0
                                ? contractPackageServicesAll.reduce((sum, item) => {
                                  const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                  const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                    cb.ChargeBasis?.id === chargeBasisId &&
                                    cb.ChargeBasis?.BasisType?.id === 2
                                  );

                                  if (exclude) return sum;

                                  const price =
                                    item.approval_price !== undefined && item.approval_price !== null
                                      ? parseFloat(item.approval_price || 0)
                                      : item.price_afterdiscount;

                                  return sum + price;
                                }, 0).toFixed(2)
                                : 0
                            }

                          </label>
                        </div>
                      </div></div>

                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="row mb-3">
                          <div className="col-md-10">
                            <label className="form-label">Package Name  :  Custom</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="table-responsive">
                        <table className="table  table-nowrap">
                          <thead>
                            <tr>
                              <th scope="col">Service Name</th>
                              <th scope="col">Price</th>
                              <th scope="col">Discounted Price</th>
                              <th scope="col">Current  Discount (%)</th>
                              <th scope="col">Approval Discount (%)</th>
                              <th scope="col">Approval Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* {
                              contractPackageServicesAll && contractPackageServicesAll.map((val, index) => (
                            val.Package == null ?
                            <tr key={index}>
                              <td>{val.Service.name}</td>
                              <td>£{val.price.toFixed(2)}</td>
                              <td>£{val.price_afterdiscount.toFixed(2)}</td>
                              <td>{val.discount_rate.toFixed(2)}</td>
                              <td><input
                                type="text"
                                className="form-control"
                                value={val.approval_discount != undefined ? (val.approval_discount).toFixed(2) : val.discount_rate}
                                disabled /></td>
                              <td><input
                                type="text"
                                className="form-control"
                                value={val.approval_price != undefined ? val.approval_price : val.price_afterdiscount.toFixed(2)}
                                onChange={(e) => applyApprovalPrice(e, val, index)}
                              />
                                {approvalErrors[index] && (
                                  <div className="text-danger mt-1">{approvalErrors[index]}</div>
                                )}
                              </td>

                            </tr> : ""
                              ))} */}

                            {
                              contractPackageServicesAll &&
                              contractPackageServicesAll.map((val, index) => {
                                const isValidChargeBasis = val.Service?.ServiceChargeBases?.some(cb =>
                                  cb.ChargeBasis &&
                                  cb.ChargeBasis.id === val.sell_chargebasis_id &&
                                  cb.ChargeBasis.basistypes_id === 2
                                );

                                return val.Package == null ? (
                                  <tr key={index}>
                                    <td>
                                      {isValidChargeBasis ? val.Service.name + "(Hourly)" : val.Service.name}
                                    </td>
                                    <td>£{val.price.toFixed(2)}</td>
                                    <td>£{val.price_afterdiscount.toFixed(2)}</td>
                                    <td>{

                                      isValidChargeBasis ?
                                        "-"
                                        :
                                        val.discount_rate.toFixed(2)

                                    }</td>
                                    <td>

                                      {
                                        isValidChargeBasis ?
                                          "-"
                                          :
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={val.approval_discount != undefined ? val.approval_discount.toFixed(2) : val.discount_rate}
                                            disabled
                                          />

                                      }


                                    </td>
                                    <td>

                                      <input
                                        type="text"
                                        className="form-control"
                                        value={val.approval_price != undefined ? val.approval_price : val.price_afterdiscount.toFixed(2)}
                                        onChange={(e) => applyApprovalPrice(e, val, index)}
                                      />
                                      {approvalErrors[index] && (
                                        <div className="text-danger mt-1">{approvalErrors[index]}</div>
                                      )}
                                    </td>
                                  </tr>
                                ) : null;
                              })
                            }


                          </tbody>
                        </table>
                      </div>
                    </div>




                    <div className="row mb-3">
                      <label className="col-sm-4 col-md-2 col-form-label">
                        <strong>Reason:</strong>
                      </label>
                      <div className="col-sm-8 col-md-10 ">
                        <textarea
                          ref={textareaRef}
                          value={reasonHigherDiscount}
                          name="reason_higher_discount"
                          onChange={(e) => setReasonHigherDiscount(e.target.value)}
                          placeholder="Please Enter Reason For Higher Discount"
                          style={{
                            width: "100%",
                            minHeight: "40px",
                            maxHeight: "300px",
                            overflowY: "hidden",
                            padding: "8px",
                            fontSize: "16px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>
                    </div>

                  </div>


                </>
              }
              footer={
                <>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-pink"
                    onClick={(e) => submitReqHigherDiscount(e)}
                    disabled={loading}
                  > {loading ? "Submitting..." : "Submit"}</button>
                </>
              }
            />
          </>


      }



    </div>
  );
};

export default StepThree;
